import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from 'primereact/dialog';
import { Button } from '../../../../../../components/ui/Button';
import { InputText } from 'primereact/inputtext';

const NameValidationModal = ({ visible, onHide, onSave, isDarkMode }) => {
    const { t } = useTranslation();
    const [localName, setLocalName] = useState('');
    const [error, setError] = useState('');

    const handleSave = () => {
        if (!localName.trim()) {
            setError(t('layouts.designer_please_enter_name'));
            return;
        }
        onSave(localName);
        setLocalName('');
        setError('');
    };

    const handleClose = () => {
        setLocalName('');
        setError('');
        onHide();
    };

    return (
        <Dialog
            visible={visible}
            style={{ width: '400px' }}
            modal
            onHide={handleClose}
            draggable={false}
            resizable={false}
            showHeader={false}
            contentClassName={`custom-modal-content !p-0 !rounded-xl overflow-hidden shadow-2xl border ${isDarkMode ? 'bg-slate-900 border-slate-700' : 'bg-white border-gray-100'}`}
        >
             <div className="flex flex-col gap-6 p-8">
                <div className="text-center">
                    <div className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 animate-bounce-slow ${isDarkMode ? 'bg-amber-500/20 text-amber-500' : 'bg-amber-50 text-amber-600'}`}>
                        <i className='bx bxs-edit text-3xl'></i>
                    </div>
                    <h3 className={`text-xl font-bold mb-2 tracking-tight ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{t('layouts.designer_name_your_layout')}</h3>
                    <p className={`text-sm leading-relaxed ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        {t('layouts.designer_name_your_layout_desc')}
                    </p>
                </div>

                <div className="flex flex-col gap-1">
                    <label className={`text-xs font-semibold uppercase tracking-wider ml-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{t('layouts.designer_layout_name_label')}</label>
                    <InputText 
                        value={localName} 
                        onChange={(e) => {
                            setLocalName(e.target.value);
                            if(e.target.value.trim()) setError('');
                        }}
                        placeholder="e.g., Summer Campaign 2024"
                        className={`w-full p-3 rounded-lg border focus:ring-2 focus:ring-amber-500/20 transition-all ${
                            error ? 'border-red-500' : (isDarkMode ? 'border-slate-700 bg-slate-800 text-white focus:border-amber-500' : 'border-gray-300 focus:border-amber-500')
                        }`}
                        autoFocus
                    />
                    {error && (
                        <div className="flex items-center gap-1 text-red-500 mt-1 animate-fadeIn">
                            <i className='bx bx-error-circle text-xs'></i>
                            <span className="text-xs font-medium">{error}</span>
                        </div>
                    )}
                </div>

                <div className="flex gap-3 pt-2">
                    <Button
                        label={t('buttons.cancel')}
                        onClick={handleClose}
                        className={`p-button-text flex-1 justify-center font-semibold !ring-0 ${isDarkMode ? 'text-gray-400 hover:bg-slate-800 hover:text-white' : 'text-gray-500 hover:bg-gray-100 hover:text-gray-900'}`}
                    />
                    <Button
                        label={t('layouts.designer_save_layout')}
                        icon="bx bx-check"
                        onClick={handleSave}
                        className="flex-1 justify-center bg-gradient-to-r from-amber-500 to-orange-500 border-none hover:from-amber-600 hover:to-orange-600 text-white font-semibold shadow-lg shadow-amber-500/30 hover:shadow-amber-500/50 transition-all duration-300 transform hover:scale-[1.02]"
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default NameValidationModal;
